import React from 'react'
import BaseComponent from '../base'
import Field from "../common/Field";
import Validator from "../common/Validator";
import api from "../../source/api";
import NotificationSystem from "react-notification-system";
import PATH from "../../config/dev";
import User from "../../helpers/user";

class TakarekBankReplacer extends BaseComponent {

    constructor(props) {
        super(props)
        this.state = {
            processing: false,
            fields: {
                bankFile: {value: '', error: '', role: {required: true}},
            },
            error: null,
        }
    }

    _addNotification = (msg, type, time = 4) => {
        this.refs.notificationSystem.addNotification({
            message: msg,
            level: type,
            position: 'tc',
            autoDismiss: time
        })
    }

    upload = () => {
        let validator = Validator.validate(this.state.fields)
        this.setState({
            fields: validator.fields,
            error: validator.error
        });

        if (this.state.error) {
            return;
        }

        this.setState({processing: true})

        api.postFile('bank/takarek-bank-replacer', this.collectFormData())
            .then((response) => {
                if (response.status === 200) {
                    this.setState({processing: false})
                    window.open(PATH.ENDPOINT_BASE_URL + 'bank/takarek-bank-replacer/download'
                        + '?api_token=' + User.requireUser().auth_key
                        + '&name=' + response.data.file
                    )

                }
            })
            .catch((err) => {
                this.setState({processing: false})
                this._addNotification(err.response.data.error.message, 'error')
            })

    }

    collectFormData = () => {
        let form = new FormData();
        form.append('bankStatementFile', document.querySelector('#bankFile').files[0])
        return form
    }

    setValue = (name, value, error) => {
        let fields = this.state.fields;
        fields[name].value = value;
        fields[name].error = error;
        this.setState({fields: fields});
    }

    render() {
        return (
            <section id='bank-takarek-bank-replacer' className='my-5'>
                <div className='container'>

                    <div className='header'>
                        <h1>
                            Takarék Bank - Átforgatása
                        </h1>
                        <p>
                            Ez a modul a takarék bank állományát rendezi olyan struktúrává, amit utána el tud fogadni a Bank modul.<br/>
                            Lényege, hogy beállítja az előjeleket, és felcseréli a Megbízót a Címzettel.<br/>
                            Ehhez mindössze a megbízó bankszámla számára van szükség, és akkor az alapján le is szűri a listát, ha esetleg több bankszámlaszámmal rendelkezne.
                        </p>
                    </div>

                    <div className='row'>
                        <div className='col-md-10 offset-md-2 my-5'>

                            <table className='table table-bordered'>
                                <thead>
                                <tr>
                                    <th>Megnevezés</th>
                                    <th>Mező</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>
                                        Takarék bank kimutatás file
                                    </td>
                                    <td>
                                        <Field
                                            type='file'
                                            id='bankFile'
                                            name='bankFile'
                                            fileUploadEndpoint=''
                                            classLabel='control-label'
                                            classInput='file-input'
                                            setValue={this.setValue.bind(this)}
                                            state={this.state}
                                        />
                                    </td>
                                </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>

                    <div className='next-step-btn-container text-center'>
                        <a
                            onClick={() => this.upload()}
                            className={this.state.processing ? 'disabled next-step' : 'next-step'}
                        >
                            Átforgatás
                        </a>
                    </div>
                </div>
                <NotificationSystem ref='notificationSystem'/>
            </section>
        )
    }
}

export default TakarekBankReplacer


// WEBPACK FOOTER //
// ./src/components/bank/TakarekBankReplacer.js